var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "feature-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.3034244%",
    y1: "0%",
    x2: "80.9340369%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3781",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C168.429045,0 200,39.2500126 200,100 C200,160.749987 170.303194,200 100,200 C29.6968058,200 0,163.066536 0,100 C0,36.9334635 31.5709552,0 100,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.445,0 L6.555,0 C2.94063,0 0,2.9019375 0,6.46875 L0,65.53125 C0,69.0980625 2.94063,72 6.555,72 L50.445,72 C54.05937,72 57,69.0980625 57,65.53125 L57,6.46875 C57,2.9019375 54.05937,0 50.445,0 Z M43.6864051,20.4705882 L43.311359,20.4705882 C42.9335004,20.4705882 42.6267979,20.7676029 42.609501,21.1427132 C42.2548455,28.8434412 35.8374369,35 28,35 C20.1625631,35 13.7451545,28.8434412 13.390499,21.1427132 C13.3732021,20.7676029 13.0664996,20.4705882 12.688641,20.4705882 L12.3135949,20.4705882 C11.1021131,20.4705882 10.0596621,19.5455956 10.0025685,18.3434265 C9.94167798,17.0598088 10.9713321,16 12.2500326,16 L18.9364562,16 C20.1479381,16 21.1903891,16.9249926 21.2474827,18.1271618 C21.3083732,19.4107794 20.2787191,20.4705882 19.0000186,20.4705882 L18.6051444,20.4705882 C18.1967703,20.4705882 17.8726303,20.8153824 17.9028646,21.2199706 C18.2900045,26.4178676 22.6707454,30.5294118 28,30.5294118 C33.3292546,30.5294118 37.7099955,26.4178676 38.0971354,21.2199706 C38.1272291,20.8153824 37.8032297,20.4705882 37.3948556,20.4705882 L37.0635438,20.4705882 C35.8520619,20.4705882 34.8096109,19.5455956 34.7525173,18.3434265 C34.6916268,17.0598088 35.7212809,16 36.9999814,16 L43.7499674,16 C45.0286679,16 46.058322,17.0598088 45.9974315,18.3434265 C45.9403379,19.5455956 44.8978869,20.4705882 43.6864051,20.4705882 L43.6864051,20.4705882 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "36.665644%",
    y2: "96.0299424%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3F5",
    stopOpacity: 0.0897891171,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF1554",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "46.9941677%",
    y2: "71.9542941%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3F5",
    stopOpacity: 0.0897891171,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3781",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3781",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3E7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E286D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.5%",
    y: "-12.5%",
    width: "135.0%",
    height: "135.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.9805992%",
    y1: "15.1651008%",
    x2: "94.3808906%",
    y2: "121.150643%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-12",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.9%",
    y: "-15.6%",
    width: "143.8%",
    height: "143.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-14",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.5%",
    y: "-27.5%",
    width: "165.0%",
    height: "165.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-539.000000, -2076.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feature-2",
    transform: "translate(539.000000, 2076.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    transform: "translate(100.000000, 100.000000) scale(1, -1) translate(-100.000000, -100.000000) ",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    stroke: "none",
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    mask: "url(#mask-5)",
    transform: "translate(48.224950, 59.574207) rotate(2.000000) translate(-48.224950, -59.574207) ",
    points: "29.067578 74.8297249 49.5246424 35.6018049 67.382321 28.6497443 35.0439246 90.4986706"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy-2",
    stroke: "none",
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    mask: "url(#mask-5)",
    points: "33.7445964 88.0964662 66.5074332 33.0632557 76.4228126 37.7239972 45.5378911 92.7828207"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    opacity: 0.32451448,
    x: 84,
    y: 50,
    width: 20,
    height: 20,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#FFFFFF",
    opacity: 0.32451448,
    x: 51,
    y: 108,
    width: 14,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.32451448,
    x: 128,
    y: 97,
    width: 14,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    opacity: 0.32451448,
    x: 122,
    y: 120,
    width: 13,
    height: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF",
    opacity: 0.32451448,
    x: 148,
    y: 109,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(110.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-check",
    transform: "translate(9.000000, 8.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15875,4.46625 C6.21752606,4.52487766 6.25055861,4.60448296 6.25055861,4.6875 C6.25055861,4.77051704 6.21752606,4.85012234 6.15875,4.90875 L4.28375,6.78375 C4.22512234,6.84252606 4.14551704,6.87555861 4.0625,6.87555861 C3.97948296,6.87555861 3.89987766,6.84252606 3.84125,6.78375 L2.90375,5.84625 C2.82470499,5.76720499 2.7938344,5.65199437 2.82276688,5.54401688 C2.85169936,5.43603939 2.93603939,5.35169936 3.04401688,5.32276688 C3.15199437,5.2938344 3.26720499,5.32470499 3.34625,5.40375 L4.0625,6.120625 L5.71625,4.46625 C5.77487766,4.40747394 5.85448296,4.37444139 5.9375,4.37444139 C6.02051704,4.37444139 6.10012234,4.40747394 6.15875,4.46625 L6.15875,4.46625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875,0.9375 L1.25,0.9375 C0.559644063,0.9375 0,1.49714406 0,2.1875 L0,8.75 C0,9.44035594 0.559644063,10 1.25,10 L7.5,10 C8.19035594,10 8.75,9.44035594 8.75,8.75 L8.75,2.1875 C8.75,1.49714406 8.19035594,0.9375 7.5,0.9375 L6.875,0.9375 L6.875,1.5625 L7.5,1.5625 C7.84517797,1.5625 8.125,1.84232203 8.125,2.1875 L8.125,8.75 C8.125,9.09517797 7.84517797,9.375 7.5,9.375 L1.25,9.375 C0.904822031,9.375 0.625,9.09517797 0.625,8.75 L0.625,2.1875 C0.625,1.84232203 0.904822031,1.5625 1.25,1.5625 L1.875,1.5625 L1.875,0.9375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125,0.625 C5.48508898,0.625 5.625,0.764911016 5.625,0.9375 L5.625,1.5625 C5.625,1.73508898 5.48508898,1.875 5.3125,1.875 L3.4375,1.875 C3.26491102,1.875 3.125,1.73508898 3.125,1.5625 L3.125,0.9375 C3.125,0.764911016 3.26491102,0.625 3.4375,0.625 L5.3125,0.625 Z M3.4375,0 C2.91973305,0 2.5,0.419733047 2.5,0.9375 L2.5,1.5625 C2.5,2.08026695 2.91973305,2.5 3.4375,2.5 L5.3125,2.5 C5.83026695,2.5 6.25,2.08026695 6.25,1.5625 L6.25,0.9375 C6.25,0.419733047 5.83026695,0 5.3125,0 L3.4375,0 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(123.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar-check",
    transform: "translate(13.000000, 13.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375,0 C11.1791246,0 11.375,0.195875422 11.375,0.4375 L11.375,0.875 L12.25,0.875 C13.2164983,0.875 14,1.65850169 14,2.625 L14,12.25 C14,13.2164983 13.2164983,14 12.25,14 L1.75,14 C0.783501688,14 0,13.2164983 0,12.25 L0,2.625 C0,1.65850169 0.783501688,0.875 1.75,0.875 L2.625,0.875 L2.625,0.4375 C2.625,0.195875422 2.82087542,0 3.0625,0 C3.30412458,0 3.5,0.195875422 3.5,0.4375 L3.5,0.875 L10.5,0.875 L10.5,0.4375 C10.5,0.195875422 10.6958754,0 10.9375,0 Z M13.125,3.5 L0.875,3.5 L0.875,12.25 C0.875,12.7332492 1.26675084,13.125 1.75,13.125 L12.25,13.125 C12.7332492,13.125 13.125,12.7332492 13.125,12.25 L13.125,3.5 Z M9.1875,6.12421794 C9.30372385,6.12421794 9.41517127,6.17046351 9.49725,6.25275 C9.57953649,6.33482873 9.62578206,6.44627615 9.62578206,6.5625 C9.62578206,6.67872385 9.57953649,6.79017127 9.49725,6.87225 L6.87225,9.49725 C6.79017127,9.57953649 6.67872385,9.62578206 6.5625,9.62578206 C6.44627615,9.62578206 6.33482873,9.57953649 6.25275,9.49725 L4.94025,8.18475 C4.82958698,8.07408698 4.78636816,7.91279212 4.82687363,7.76162363 C4.86737911,7.61045514 4.98545514,7.49237911 5.13662363,7.45187363 C5.28779212,7.41136816 5.44908698,7.45458698 5.55975,7.56525 L6.5625,8.568875 L8.87775,6.25275 C8.95982873,6.17046351 9.07127615,6.12421794 9.1875,6.12421794 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(60.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "card-checklist",
    transform: "translate(9.000000, 10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6875,0 C13.4123737,0 14,0.587626266 14,1.3125 L14,1.3125 L14,9.1875 C14,9.91237373 13.4123737,10.5 12.6875,10.5 L12.6875,10.5 L1.3125,10.5 C0.587626266,10.5 0,9.91237373 0,9.1875 L0,9.1875 L0,1.3125 C0,0.587626266 0.587626266,0 1.3125,0 L1.3125,0 Z M12.6875,0.875 L1.3125,0.875 C1.07087542,0.875 0.875,1.07087542 0.875,1.3125 L0.875,1.3125 L0.875,9.1875 C0.875,9.42912458 1.07087542,9.625 1.3125,9.625 L1.3125,9.625 L12.6875,9.625 C12.9291246,9.625 13.125,9.42912458 13.125,9.1875 L13.125,9.1875 L13.125,1.3125 C13.125,1.07087542 12.9291246,0.875 12.6875,0.875 L12.6875,0.875 Z M4.50625,5.68671794 C4.62247385,5.68671794 4.73392127,5.73296351 4.816,5.81525 C4.89828649,5.89732873 4.94453206,6.00877615 4.94453206,6.125 C4.94453206,6.24122385 4.89828649,6.35267127 4.816,6.43475 L3.5035,7.74725 C3.42142127,7.82953649 3.30997385,7.87578206 3.19375,7.87578206 C3.07752615,7.87578206 2.96607873,7.82953649 2.884,7.74725 L2.4465,7.30975 C2.33583698,7.19908698 2.29261816,7.03779212 2.33312363,6.88662363 C2.37362911,6.73545514 2.49170514,6.61737911 2.64287363,6.57687363 C2.79404212,6.53636816 2.95533698,6.57958698 3.066,6.69025 L3.19375,6.818875 L4.1965,5.81525 C4.27857873,5.73296351 4.39002615,5.68671794 4.50625,5.68671794 Z M10.9375,6.125 C11.1791246,6.125 11.375,6.32087542 11.375,6.5625 C11.375,6.80412458 11.1791246,7 10.9375,7 L6.5625,7 C6.32087542,7 6.125,6.80412458 6.125,6.5625 C6.125,6.32087542 6.32087542,6.125 6.5625,6.125 L10.9375,6.125 Z M4.50625,2.18671794 C4.62247385,2.18671794 4.73392127,2.23296351 4.816,2.31525 C4.89828649,2.39732873 4.94453206,2.50877615 4.94453206,2.625 C4.94453206,2.74122385 4.89828649,2.85267127 4.816,2.93475 L3.5035,4.24725 C3.42142127,4.32953649 3.30997385,4.37578206 3.19375,4.37578206 C3.07752615,4.37578206 2.96607873,4.32953649 2.884,4.24725 L2.4465,3.80975 C2.33583698,3.69908698 2.29261816,3.53779212 2.33312363,3.38662363 C2.37362911,3.23545514 2.49170514,3.11737911 2.64287363,3.07687363 C2.79404212,3.03636816 2.95533698,3.07958698 3.066,3.19025 L3.19375,3.318875 L4.1965,2.31525 C4.27857873,2.23296351 4.39002615,2.18671794 4.50625,2.18671794 Z M10.9375,2.625 C11.1791246,2.625 11.375,2.82087542 11.375,3.0625 C11.375,3.30412458 11.1791246,3.5 10.9375,3.5 L6.5625,3.5 C6.32087542,3.5 6.125,3.30412458 6.125,3.0625 C6.125,2.82087542 6.32087542,2.625 6.5625,2.625 L10.9375,2.625 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(40.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9CD169",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chat-quote",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,1.47437618e-13 C7.76125,1.47437618e-13 10,1.95875 10,4.375 C10,6.79125 7.76125,8.75 5,8.75 C4.50478235,8.75066759 4.01161674,8.68636905 3.533125,8.55875 C3.208125,8.723125 2.50875,9.0225 1.365625,9.249375 C1.21754279,9.2787303 1.06898039,9.30560905 0.92,9.33 C0.795,9.35 0.7,9.22 0.749375,9.10375 C0.804869861,8.9728745 0.855734767,8.84008374 0.901875,8.705625 L0.90375,8.699375 C1.05875,8.249375 1.185,7.731875 1.23125,7.25 C0.464375,6.48125 0,5.475 0,4.375 C0,1.95875 2.23875,1.47437618e-13 5,1.47437618e-13 Z M5,0.625 C2.5025,0.625 0.625,2.38 0.625,4.375 C0.625,5.2925 1.010625,6.14375 1.67375,6.80875 C1.80509436,6.9405963 1.87085014,7.12411678 1.853125,7.309375 C1.80919933,7.7328613 1.72592296,8.15133553 1.604375,8.559375 C2.47625,8.3575 3.00875,8.12375 3.250625,8.00125 C3.38781447,7.93176558 3.54580563,7.9152989 3.694375,7.955 C4.12027178,8.06854253 4.55922853,8.12569726 5,8.125 C7.4975,8.125 9.375,6.370625 9.375,4.375 C9.375,2.38 7.4975,0.625 5,0.625 Z M3.24511546,3.1644909 C3.68890549,3.03306189 4.16616291,3.21053932 4.41625,3.6 L4.41625,3.6 C4.798125,4.1625 4.91875,5.20875 3.99,6.17125 C3.88989839,6.27480339 3.72480339,6.27760161 3.62125,6.1775 C3.51769661,6.07739839 3.51489839,5.91230339 3.615,5.80875 C3.86625,5.54875 4.01875,5.289375 4.100625,5.04625 C3.77987265,5.25005416 3.37359703,5.26305136 3.04047403,5.08016541 C2.70735104,4.89727945 2.50022825,4.54752388 2.49998678,4.1675 C2.49767809,3.70466333 2.80132542,3.29591991 3.24511546,3.1644909 Z M5.74511546,3.1644909 C6.18890549,3.03306189 6.66616291,3.21053932 6.91625,3.6 L6.91625,3.6 C7.298125,4.1625 7.41875,5.20875 6.49,6.17125 C6.38989839,6.27480339 6.22480339,6.27760161 6.12125,6.1775 C6.01769661,6.07739839 6.01489839,5.91230339 6.115,5.80875 C6.36625,5.54875 6.51875,5.289375 6.600625,5.04625 C6.27987265,5.25005416 5.87359703,5.26305136 5.54047403,5.08016541 C5.20735104,4.89727945 5.00022825,4.54752388 4.99998678,4.1675 C4.99767809,3.70466333 5.30132542,3.29591991 5.74511546,3.1644909 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(30.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "url(#linearGradient-16)",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "emoji-heart-eyes-fill",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C2.23857625,0 0,2.23857625 0,5 C0,7.76142375 2.23857625,10 5,10 C7.76142375,10 10,7.76142375 10,5 C10,2.23857625 7.76142375,0 5,0 Z M2.9725,2.85375 C3.449375,1.96375 5.485,2.77875 3.5675,5 C0.7575,4.0025 2.09875,2.31375 2.9725,2.85375 Z M7.071875,6.25875 C7.19312682,6.23020213 7.31975268,6.27639196 7.39414501,6.37630575 C7.46853735,6.47621954 7.47648608,6.61077224 7.414375,6.71875 C6.91206034,7.58930076 5.98320133,8.1254559 4.978125,8.12500029 C3.97304867,8.1254559 3.04418966,7.58930076 2.541875,6.71875 C2.47976392,6.61077224 2.48771265,6.47621954 2.56210499,6.37630575 C2.63649732,6.27639196 2.76312318,6.23020213 2.884375,6.25875 L2.8875,6.25875 L2.898125,6.261875 L2.94,6.27125 L3.0975,6.305625 C3.231875,6.334375 3.419375,6.373125 3.633125,6.41125 C4.06625,6.48875 4.584375,6.5625 4.978125,6.5625 C5.371875,6.5625 5.890625,6.48875 6.323125,6.41125 C6.55513381,6.3695064 6.78622781,6.32282916 7.01625,6.27125 L7.058125,6.261875 L7.06875,6.259375 L7.071875,6.258125 L7.071875,6.25875 Z M7.028125,2.85375 C7.90125,2.31375 9.2425,4.0025 6.4325,5 C4.515625,2.77875 6.55125,1.96375 7.0275,2.85375 L7.028125,2.85375 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack3);
export default __webpack_public_path__ + "static/media/pack-3.2df5d45429cf21497fefa30498d98d1d.svg";
export { ForwardRef as ReactComponent };